var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / SV") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C7839",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31642E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-SV",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#1B57C4",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#1B57C4",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6006443,7.86695547 C16.2479827,8.35349516 16.6666667,9.12785314 16.6666667,10 C16.6666667,11.4727593 15.4727593,12.6666667 14,12.6666667 C12.5272407,12.6666667 11.3333333,11.4727593 11.3333333,10 C11.3333333,9.12803013 11.7518473,8.35380945 12.3989616,7.86725172 L13.3333333,10.6666667 L14.6666667,10.6666667 Z",
    id: "Oval-12",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-483",
    fill: "#F9C92E",
    mask: "url(#mask-2)",
    points: "14 7.33333333 14.6666667 10.6666667 13.3333333 10.6666667"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/SV.b82c7a14040fe5fb52e6137fcee38efd.svg";
export { ForwardRef as ReactComponent };